// Temporary organization policy, with no expiry. Re-enable only after an explicit
// strategy decision. This client guard complements the server indexing pause;
// Stream permission enforcement is still required for older/direct clients.
const PAUSED_ORG_ID = "a25f9e42-23cd-11ec-9068-066917b38554";

export function isChatCreationPaused(orgId) {
	return orgId === PAUSED_ORG_ID;
}

export function installChatCreationPause(client, getSelectedOrgId) {
	const post = client.post;
	client.post = function (url, body, ...rest) {
		// SDK create(), watch() and query() all use this get-or-create endpoint,
		// including distinct channels without an ID. queryChannels uses /channels.
		const createsOrQueriesChannel = /\/channels\/[^/?]+(?:\/[^/?]+)?\/query(?:[?#]|$)/.test(String(url));
		const targetOrgId = body && body.data && body.data.team;
		if (createsOrQueriesChannel && (isChatCreationPaused(getSelectedOrgId()) || isChatCreationPaused(targetOrgId))) {
			const error = new Error("Chat creation is paused for this organization.");
			error.code = 403;
			error.status = 403;
			error.reason = "ICH_CHAT_CREATION_PAUSED";
			return Promise.reject(error);
		}
		return post.call(this, url, body, ...rest);
	};
	return client;
}
